<script>
import jQuery from 'jquery';
export default {
  name: 'App',
  created() {
    window.jQuery = jQuery;
  },
  mounted() {
    this.setFont();
    window.addEventListener('resize', () => this.setFont(), false);
    this.$nextTick().then(
      Object.defineProperty(Event.prototype, 'path', {
        get() {
          return this.composedPath();
        },
      })
    );
  },
  methods: {
    // 设置rem样式自适应
    setFont(data) {
      if (data) {
        var cliWidth = data - 10;
      } else {
        var html = document.documentElement;
        var cliWidth = html.clientWidth - 10;
      }
      this.$nextTick(() => {
        document.documentElement.style.fontSize = 10 * (cliWidth / 1920) + 'px';
      });
    },
  },
};
</script>

<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<style lang="less">
#app {
  font-family: Segoe UI Symbol !important;
}
/* 自定义样式控件 */
.ol-custom-overviewmap,
.ol-custom-overviewmap.ol-uncollapsible {
  bottom: auto;
  left: auto;
  right: 0;
  /*右侧显示*/
  bottom: 0;
  z-index: 996;
  /*顶部显示*/
}

/* 鹰眼控件展开时控件外框的样式 */

.ol-custom-overviewmap:not(.ol-collapsed) {
  border: 1px solid black;
}

/* 鹰眼控件中地图容器的样式 */

.ol-custom-overviewmap .ol-overviewmap-map {
  border: none;
  width: 300px !important;
}
.ol-overviewmap {
  right: 6.5rem !important;
  bottom: 0.5rem !important;
  left: unset !important;
}

.ol-control button {
  position: absolute;
  bottom: 108px;
  right: 8px;
  width: 1.8em;
  height: 1.8em;
  cursor: pointer;
}

/* 在鹰眼控件中显示当前窗口中主图区域的边框 */

.ol-custom-overviewmap .ol-overviewmap-box {
  border: 2px solid red;
}

/* 在鹰眼控件张开时其控件按钮图标的样式 */

.ol-custom-overviewmap:not(.ol-collapsed) button {
  bottom: auto;
  left: auto;
  right: 1px;
  top: 1px;
}

// 隐藏页面滚动条
::-webkit-scrollbar {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue